/* Copyright (C) 2019 SmartboxTv S.A. - All rights reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Christian Santa María <csantamaria@smartboxtv.com>
 */

import React from 'react';
import { Input } from 'semantic-ui-react';
import { inject, observer } from 'mobx-react';
import get from 'lodash/get';

@inject('storeAppearanceStore')
@observer
class AppNameInput extends React.Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.abortRequest = this.abortRequest.bind(this);
        this.state = {
            valid: 'initial',
            firstCheck: true,
        };
        this.firstCheck = true;
        this.request = false;
        this.abortFunc = false;
    }

    abortRequest(cb) {
        this.abortFunc = cb;
    }

    UNSAFE_componentWillReceiveProps(nextProps, nextState) {
        if (nextProps.defaultValue && this.firstCheck === true) {
            this.firstCheck = false;
            this.props.storeAppearanceStore
                .checkAppName(get(nextProps, 'defaultValue', ''), this.abortRequest)
                .then(res => {
                    if (res === true) {
                        this.setState({ valid: true });
                    } else {
                        this.setState({ valid: false });
                    }
                })
                .catch(err => {
                    this.setState({ valid: false });
                });
        }
    }

    async onChange(e, d) {
        if (this.props.onChange) this.props.onChange(e, d);

        const appName = d.value;

        if (appName === this.props.defaultValue) {
            if (this.abortFunc) {
                this.abortFunc();
                this.abortFunc = false;
            }
            this.setState({ valid: 'initial' });
            return;
        }

        if (this.abortFunc) {
            this.abortFunc();
            this.abortFunc = false;
        }
        const res = await this.props.storeAppearanceStore.checkAppName(appName, this.abortRequest);
        if (res === true) {
            this.setState({ valid: true }, this.onValidChange);
        } else if (res && res.error) {
            this.setState({ valid: false }, this.onValidChange);
        }
    }

    onValidChange = () => {
        if (this.props.onValidChange) this.props.onValidChange(this.state.valid);
    };

    render() {
        const { labelText, labelPosition, storeAppearanceStore, defaultValue, ...rest } = this.props;
        const { valid } = this.state;
        return (
            <React.Fragment>
                <Input
                    {...rest}
                    onChange={this.onChange}
                    error={valid === false}
                    className={valid === true ? 'available' : ''}
                />
            </React.Fragment>
        );
    }
}

export default AppNameInput;
